import { useState } from "react";
import axios from "../../services/axios/config";
import { Button, Tooltip } from "@mantine/core";
import IconDownload from "@tabler/icons-react/dist/esm/icons/IconDownload.mjs";
import classes from "./exportBtn.module.scss";

export default function ExportBtn({ exportUrl, method, name }) {
  const [loading, setLoading] = useState(false);
  const downloadHandler = async () => {
    try {
      setLoading(true);
      const response = await axios({
        url: exportUrl,
        method,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const anchor = document.createElement("a");
      anchor.style.display = "none";
      anchor.href = url;
      anchor.download = `${name}.xlsx`;
      document.body.appendChild(anchor);
      anchor.click();

      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip label="Export">
      <Button
        onClick={downloadHandler}
        loading={loading}
        className={classes["export-btn"]}
      >
        <IconDownload color="gray" />
      </Button>
    </Tooltip>
  );
}
